import { IStore } from '../../reducers/index'

const gameSettingsSelector = (state: IStore) => state.game.settings

export default gameSettingsSelector
